import { NgxHttpClient } from '@app/shared/ngx-http-client';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  public readonly refreshSessionTimeoutUrl = '/user/RefreshSessionTimeout';

  /** Session modal duration in seconds */
  public readonly modalTimeout = 60;

  constructor(
    private http: NgxHttpClient,
    private cookieService: CookieService
  ) {}

  /** Session expiration date. Returns undefined if expiration is in the past. */
  public get expiration(): Date | undefined {
    if (this.expiresUtc > new Date()) {
      return this.expiresUtc;
    }
  }

  /** Seconds remaining before session expires */
  public get sessionTimeout(): number {
    return Math.floor((+this.expiresUtc - +new Date()) / 1000);
  }

  /** Seconds remaining before session expiration modal is displayed */
  public get showModalTimeout(): number {
    // Note this returns 0 for negative values
    const timeout = Math.max(0, this.sessionTimeout - this.modalTimeout);
    // If the modal timeout >= the session timeout we need to adjust to avoid a race condition.
    // Note that this mostly applies to dev testing as its unlikely any orgs will have a session timeout of 1 min.
    return timeout || this.sessionTimeout - 30;
  }

  /** Get session expiration in date format */
  private get expiresUtc(): Date {
    const timeout = this.cookieService.get('sessionTimeout');
    return new Date(decodeURIComponent(timeout));
  }

  /** Reset the users session timeout */
  public renewSessionTimeout(): Observable<void> {
    return this.http.post<void>(this.refreshSessionTimeoutUrl, null);
  }
}
